import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { graphql, compose } from 'react-apollo';
import gql from 'graphql-tag';

// https://stripe.com/docs/checkout#integration-custom
import StripeHOC from './StripeHOC';

import Segment from '../../../../components/Segment';
import Spinner from '../../../../components/Spinner/';
import Logo from '../../components/Logo';
import Background from '../../components/Background';
import Card from '../../components/Card';

import Doge from '../../assets/doge.jpg';

import './style.scss';

const STRIPE_PUBLIC_KEY =
  process.env.NODE_ENV === 'production-s' ||
    process.env.NODE_ENV === 'production'
    ? 'pk_live_sbgC0xvn8rSpdUGLi6fGrrSo'
    : 'pk_test_wCnZXGXx4bozyLuDrZX33r8P';

const segment = new Segment();

const SaveUserMutation = gql`
  mutation($advisorID: Int!, $tokenID: String!) {
    updateUserAssessmentBooked(advisorID: $advisorID, tokenID: $tokenID) {
      id
    }
  }
`;

const SavePhoneMutation = gql`
  mutation($phone: String) {
    updateUser(input: { phone: $phone }) {
      phone
    }
  }
`;

class Booking extends React.Component {
  state = {
    isFetching: false,
    isLearnMore: false,
    phone: '',
  };

  componentWillMount() {
    const { isAuthenticated, advisor } = this.props;
    if (!isAuthenticated || !advisor) {
      this.props.router.push({
        pathname: '/assessment',
      });
    }
  }

  componentDidMount() {
    const { advisor } = this.props;

    if (window.StripeCheckout) {
      const { authedUser } = this.props;
      const email = _.get(authedUser, 'email');
      this.stripeHandler = window.StripeCheckout.configure({
        key: STRIPE_PUBLIC_KEY,
        image: '../images/assessment/logo-square.png',
        locale: 'auto',
        email,
        allowRememberMe: false,
        token: token => {
          // You can access the token ID with `token.id`.
          // Get the token ID to your server-side code for use.
          console.log('STRIPE', token);

          this.saveUserBooking(advisor.id, token.id);
        },
      });

      // Close Checkout on page navigation:
      window.addEventListener('popstate', () => {
        this.stripeHandler.close();
      });
    }
  }

  async saveUserBooking(advisorID, tokenID) {
    const { location: { state } } = this.props;

    segment.track('step8_paid');

    try {
      this.setState({
        isFetching: true,
      });

      const response = await this.props.SaveUserBooking({
        variables: {
          tokenID,
          advisorID,
        },
      });

      console.log('save', response);

      this.props.router.push({
        pathname: '/assessment/confirmation',
        state: {
          ...state,
          isBooked: true,
        },
      });
    } catch (err) {
      console.log('save err', err);
    } finally {
      this.setState({
        isFetching: false,
      });
    }
  }

  handleClickBook = () => {
    const { advisor } = this.props;

    segment.track('step7_clicked_pay', {
      id: advisor.id,
      email: advisor.email,
      first_name: advisor.first_name,
      last_name: advisor.last_name,
    });

    if (this.stripeHandler) {
      this.stripeHandler.open({
        name: 'Paragon One',
        description: 'Career Pro',
        zipCode: true,
        amount: 19900,
      });
    }
  };

  handleClickCall = () => {
    const { location: { state } } = this.props;
    const { phone } = this.state;

    segment.track('step8_callme');

    this.setState({
      isFetching: true,
    });

    this.props
      .SaveUserPhone({
        variables: {
          phone,
        },
      })
      .then(() =>
        this.props.router.push({
          pathname: '/assessment/confirmation',
          state: {
            ...state,
            isBooked: null,
            phoneBooking: true,
          },
        }),
    )
      .catch(err => {
        console.log(err);
        this.setState({
          isFetching: false,
        });
      });
  };

  handleLearnMore = event => {
    event.preventDefault();

    segment.track('step7_learn_more_phone');

    this.setState({
      isLearnMore: true,
    });
  };

  handleBookNowInstead = event => {
    event.preventDefault();

    segment.track('step8_book_now_instead');

    this.setState({
      isLearnMore: false,
    });
  };

  handleChangePhone = event => {
    this.setState({
      phone: event.target.value,
    });
  };

  handleClickChoose = event => {
    event.preventDefault();

    segment.track('step7_different_advisor');

    const { advisors } = this.props;
    const to = {
      pathname: '/assessment/advisors',
      state: {
        advisors,
      },
    };
    this.props.router.push(to);
  };

  getTopicForSelectedHelp(selectedHelp) {
    let topic = '';
    switch (selectedHelp) {
      case 'choosing-a-career':
        topic = 'choosing a career';
        break;
      case 'developing-my-career':
        topic = 'developing my career';
        break;
      case 'securing-more-interviews':
        topic = 'securing more interviews';
        break;
      case 'interviewing-successfully':
        topic = 'interviewing successfully';
        break;
    }

    return topic;
  }

  getHeading() {
    return <div className="booking__heading">Connect with:</div>;
  }

  getCard() {
    const { advisor, location } = this.props;
    const selectedHelp = _.get(location, 'state.selectedHelp');

    const topic = selectedHelp
      ? this.getTopicForSelectedHelp(selectedHelp)
      : 'the topic you chose';

    const {
      // id,
      first_name: firstName,
      last_name: lastName,
      advisor_info: advisorInfo,
      photo,
    } = advisor;
    const { position, company } = advisorInfo;

    const { isLearnMore } = this.state;

    // TODO: this should not be hardcoded
    const imgSrc = photo
      ? '//paragonone-paragon-photo-management-photo-cache-prod.paragonone.com/300x300/' +
      photo
      : Doge;

    return (
      <div className="booking__card">
        <Card>
          <div className="booking__advisor">
            <div className="booking__image">
              <img src={imgSrc} />
            </div>
            <div className="booking__name">{`${firstName} ${lastName}`}</div>
            <div className="booking__title">{`${position} at ${company}`}</div>
          </div>
          <div className="booking__package">
            <div className="booking__package__name">Career Pro Package</div>
            <div className="booking__package__price">$199</div>
          </div>
          <div className="booking__features">
            <div className="booking__included">Included in your package:</div>
            <ul className="booking__feature">
              <li>
                One 30-minute session with industry insider{' '}
                {`${firstName} ${lastName}`} on {topic}
              </li>
              <li>
                One 1-hour session with a coach from Paragon One on the topic
                you chose
              </li>
              <li>
                Invitation to our online community to connect with students and
                job opportunities
              </li>
              <li>
                Personalized career learning plan with recommended learning
                topics and advisors
              </li>
              <li>Online courses on interview prep and success</li>
              <li>100+ advice videos from our industry insiders</li>
            </ul>
          </div>
          {isLearnMore ? this.getLearnMoreCTA() : this.getCTA()}
        </Card>
      </div>
    );
  }

  getCTA() {
    const { isFetching } = this.state;

    const buttonComponent = isFetching ? (
      <Spinner className="spinner--white" />
    ) : (
        'Book Now'
      );

    return (
      <div>
        <div className="booking__book-now">
          <button
            type="button"
            className="btn btn-paragon-one"
            onClick={this.handleClickBook}
            disabled={isFetching}
          >
            {buttonComponent}
          </button>
        </div>
        {!isFetching && (
          <div>
            <div className="booking__back">
              <a href="/assessment/advisors" onClick={this.handleClickChoose}>
                Choose a different advisor
              </a>
            </div>
            <div className="booking__skip">
              <div>or</div>
              <div>
                <a href="#" onClick={this.handleLearnMore}>
                  Learn more over the phone
                </a>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }

  getLearnMoreCTA() {
    const { isFetching } = this.state;

    return (
      <div>
        <div className="assessment__input booking__phone__input">
          <input
            type="text"
            placeholder="Enter your phone number"
            value={this.state.phone}
            onChange={this.handleChangePhone}
          />
        </div>

        <div className="booking__book-now">
          <button
            type="button"
            className="btn btn-paragon-one"
            onClick={this.handleClickCall}
          >
            {isFetching ? <Spinner className="spinner--white" /> : 'Call Me'}
          </button>
        </div>

        <div>
          <a href="#" onClick={this.handleBookNowInstead}>
            Book now instead
          </a>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div>
        <Background />
        <Logo />
        <div className="assessment__wrapper--narrow">
          {this.getHeading()}
          {this.getCard()}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const advisors = _.get(ownProps, 'location.state.advisors');
  const advisor = _.get(ownProps, 'location.state.advisor');
  return {
    authedUser: _.get(state, 'auth.User'),
    isAuthenticated: !!_.get(state, 'auth.sub'),
    advisors,
    advisor,
  };
};

const mapDispatchToProps = {};

export default store => ({
  path: 'booking',
  component: connect(mapStateToProps, mapDispatchToProps)(
    StripeHOC(
      compose(
        graphql(SaveUserMutation, {
          name: 'SaveUserBooking',
        }),
        graphql(SavePhoneMutation, {
          name: 'SaveUserPhone',
        }),
      )(Booking),
    ),
  ),
});



// WEBPACK FOOTER //
// ./src/routes/assessment/routes/Booking/index.js